import type { FaireProductEntity } from "../../entity_types/product";

export const p_72zquujxbk: FaireProductEntity = {
  token: "p_72zquujxbk",
  type: "product",
  name: "Copper Sri Yantra  Pyramid, Vastu Sri Yantra Copper Pyramid",
  brandToken: "b_raqzmc7tej",
  brandName: "AmazeU",
  imageUrl:
    "https://cdn.faire.com/fastly/63e0a45e039c9fb9df08b8c815417d50bc3d64596d83a33d9d43050df6de22f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d59e6c8cb5c396f408d2331fabccc51198b1f28b8f021ed31a7aa007f8ace99f.jpeg",
    "https://cdn.faire.com/fastly/02c3838684c29a65f67d8877502109136f8e68f8194aee5b3a5daaecbf983b95.jpeg",
    "https://cdn.faire.com/fastly/b05c0491f7c1f95f86ee81b518e51f12dfa85589033150c57fb1d4edba7a92a2.jpeg",
  ],
  priceDollars: 15.94,
  description:
    "NOTE: ALL ORDERS FROM USA WILL BE SHIPPED AS DUTY PRE-PAID SHIPMENTS\n==============================\n \n- Material: Premium Quality Copper\n- Size:  3 inches\n- Hollow\n- Bottom open\n\nAuspicious Pyramid as combination of Shree Yantra, Shree Ganesha Yantra, Shree Kuber Yantra, and Kanakdhara Yantra\n\nVastu Sri Yantra Copper Pyramid made with pure copper, with 4 Powerful 4 Vastu Yantras.\nFour side contains 4 vastu yantras : Shri Yantra, Sri Ganesh Yantra, Kanakdhara Yantra, Kuber Yantra",
  tags: [],
  msrpDollars: 31.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:28.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
